// TODO: Consider using a context provider or global i18n instance for error screens
const fallbacks: Record<string, string> = {
  error_wiring_dependencies: "Error wiring dependencies",
  error_constructing_application: "Error constructing application",
  error_wire_validation: "Unknown error occurred during wire validation",
};

const getTranslation = (key: string) => fallbacks[key] || key;

export const FatalStartupErrorScreen = (error: unknown) => {
  if (error instanceof Error) {
    return (
      <div>
        <h3>{getTranslation("error_wiring_dependencies")}</h3>
        <p>{error.message}</p>
      </div>
    );
  }
  return (
    <div>
      <h3>{getTranslation("error_constructing_application")}</h3>
      <p>{getTranslation("common.unknown_error_occurred_during_wire_validation")}</p>
    </div>
  );
};
